// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tax-bill.page.title': 'Tax Bills',
    'tax-bill.page.search_results': 'Search Results',
    'tax-bill.page.search.title': 'Find Tax Bills',
    'tax-bill.page.all': 'All',

    'tax-bill.button.cancel': 'Cancel',
    'tax-bill.button.select': 'Select',
    'tax-bill.button.find': 'Find Tax Bills',
    'tax-bill.button.search': 'Apply',
    'tax-bill.button.delete': 'Permanently Delete',
    'tax-bill.button.edit': 'Edit',
    'tax-bill.button.restore': 'Restore',
    'tax-bill.button.reset': 'Reset',

    'tax-bill.placeholder.search': 'Search tax bills',

    'tax-bill.link.create_first_tax_bill': 'Click here to create your first tax bill',
    'tax-bill.link.tax_bills': ' Return to Tax Bills',
    'tax-bill.link.retry': 'Click here to retry',

    'tax-bill.checkbox.all': 'Check All',
    'tax-bill.checkbox.actions_label': 'with selected',

    'tax-bill.label.item': 'Item',
    'tax-bill.label.credit': 'Tax Credit',
    'tax-bill.label.tax_credit_total': 'Total Tax Credit',
    'tax-bill.label.tax_amount': 'Tax Amount',
    'tax-bill.label.total': 'Total',
    'tax-bill.label.subtotal': 'Subtotal',
    'tax-bill.label.bill_from': 'Bill From',
    'tax-bill.label.account': 'Account',
    'tax-bill.label.grand_total': 'Grand Total',
    'tax-bill.label.balance': 'Balance',

    'tax-bill.label.tax_submission_name': 'Tax Submission',
    'tax-bill.label.tax_bill_number': 'Tax Bill Number',

    'tax-bill.label.from__transaction_date': 'From transaction date',
    'tax-bill.label.to__transaction_date': 'To transaction date',
    'tax-bill.label.transaction_date': 'Transaction Date',

    'tax-bill.label.from__paid_at': 'From paid at',
    'tax-bill.label.to__paid_at': 'To paid at',
    'tax-bill.label.paid_at': 'Paid At',

    'tax-bill.label.from__due_at': 'From due at',
    'tax-bill.label.to__due_at': 'To due at',
    'tax-bill.label.due_at': 'Due At',
    'tax-bill.label.entity_name': 'Tax Authority',
    'tax-bill.label.province': 'Province',
    'tax-bill.label.postal_code': 'Postal Code',
    'tax-bill.label.country_name': 'Country',
    'tax-bill.label.currency_name': 'Currency',

    'tax-bill.label.from__currency_grand_total_in_cents': 'From currency grand total in cents',
    'tax-bill.label.to__currency_grand_total_in_cents': 'To currency grand total in cents',
    'tax-bill.label.currency_grand_total_in_cents': 'Currency Grand Total In Cents',

    'tax-bill.label.from__currency_balance_owing_in_cents': 'From currency balance owing in cents',
    'tax-bill.label.to__currency_balance_owing_in_cents': 'To currency balance owing in cents',
    'tax-bill.label.currency_balance_owing_in_cents': 'Currency Balance Owing In Cents',

    'tax-bill.label.from__base_grand_total_in_cents': 'From base grand total in cents',
    'tax-bill.label.to__base_grand_total_in_cents': 'To base grand total in cents',
    'tax-bill.label.base_grand_total_in_cents': 'Base Grand Total In Cents',

    'tax-bill.label.from__base_balance_owing_in_cents': 'From base balance owing in cents',
    'tax-bill.label.to__base_balance_owing_in_cents': 'To base balance owing in cents',
    'tax-bill.label.base_balance_owing_in_cents': 'Base Balance Owing In Cents',

    'tax-bill.label.from__system_grand_total_in_cents': 'From system grand total in cents',
    'tax-bill.label.to__system_grand_total_in_cents': 'To system grand total in cents',
    'tax-bill.label.system_grand_total_in_cents': 'System Grand Total In Cents',

    'tax-bill.label.from__system_balance_owing_in_cents': 'From system balance owing in cents',
    'tax-bill.label.to__system_balance_owing_in_cents': 'To system balance owing in cents',
    'tax-bill.label.system_balance_owing_in_cents': 'System Balance Owing In Cents',
    'tax-bill.label.status': 'Status',

    'tax-bill.sort.field_label': 'Field',
    'tax-bill.sort.direction_label': 'Direction',
    'tax-bill.sort.direction_ascending': 'Ascending',
    'tax-bill.sort.direction_descending': 'Descending',

    'tax-bill.modal.title.tax_bill_delete_permanently': 'Delete Tax Bill',
    'tax-bill.modal.title.tax_bill_restore': 'Restore Tax Bill',

    'tax-bill.modal.message.tax_bill_delete_permanently':
        'Are you sure that you want to permanently delete this tax bill? This action cannot be undone. | Are you sure that you want to permanently delete these tax bills? This action cannot be undone.',
    'tax-bill.modal.message.tax_bill_restore': 'Are you sure that you want to restore this tax bill? | Are you sure that you want to restore these tax bills?',

    'tax-bill.success.message.tax_bill_created': 'Your tax bill has been created',
    'tax-bill.success.message.tax_bill_updated': 'Your tax bill has been updated',
    'tax-bill.success.message.tax_bill_restored': 'Your tax bill has been restored | All selected tax bills were restored',
    'tax-bill.success.message.tax_bill_deleted': 'Your tax bill has been permanently deleted | All selected tax bills were permanently deleted',

    'tax-bill.error.message.tax_bill_deleted': 'This tax bill was already permanently deleted | These tax bills were already permanently deleted',
    'tax-bill.error.message.tax_bill_restored': 'This tax bill was already restored | These tax bills were already restored',
    'tax-bill.error.message.error_loading_page': 'Sorry, there was an error loading tax bill.| Sorry, there was an error loading tax bills.',
};
